declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return

  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', '1284151853554260')
  window.fbq('track', 'PageView')

  initialized = true
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(callback?: () => void) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Voice of Freedom - The Legacy of CK',
      content_type: 'product',
      value: 14.97,
      currency: 'USD',
    })
  }
  // Give the pixel time to fire before redirecting
  if (callback) {
    setTimeout(callback, 300)
  }
}
